import { Injectable, Injector } from '@angular/core';
import { BaseService } from './base.service';

export interface ISimcardDetails {
  SimcardErrorMessageEn: string;
  SimcardErrorMessageNl: string;
  SimcardErrorMessagePl: string;
  SimCardPrefix: string;
  SimcardRegex: string;
}

export interface IPortingRequest {
  applicantName: string;
  applicantAddress: string;
  applicantPostcode: string;
  applicantCity: string;
  applicantMobile: string;
  applicantEmail: string;
  transferDate: Date;
  lebaraMobile: string;
  lebaraSIMCard: string;
  eeccScheme: number;
}

export interface IPortingAnswer {
  svSiteUrl: string;
  errorCode?: string;
}

@Injectable({
  providedIn: 'root'
})
export class HomeService extends BaseService {
  public phoneNumber: string;
  public svSiteUrl: string;

  constructor(injector: Injector) {
    super(injector);
  }

  public getSimcardDetails(): Promise<ISimcardDetails> {
    return this.getFromHost('Home/GetSimcardDetails');
  }

  public verifyNumberToBePorted(numberToBePorted: string): Promise<string> {
    return this.getFromHost('Home/VerifyPhoneNumberToBePorted', {
      numberToBePorted: numberToBePorted
    });
  }

  public verifyNewNumber(newNumber: string, numberToBePorted: string): Promise<string> {
    return this.getFromHost('Home/VerifyNewNumber', {
      newNumber: newNumber,
      numberToBePorted: numberToBePorted
    });
  }

  public sendRequest(portingRequest: IPortingRequest): Promise<IPortingAnswer> {
    return this.postToHost('Home/SubmitRequest', portingRequest);
  }
}
